import { ConfigurationActions } from './components/ConfigurationActions'
import { ExecutionActions } from './components/ExecutionActions'

interface Props {
  tab: number
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function PreviewActions(props: Props) {
  const { tab, extOrder } = props

  switch (tab) {
    case 0:
    case 2:
      return <ConfigurationActions extOrder={extOrder} tab={tab} />
    case 1:
      return <ExecutionActions extOrder={extOrder} />
    default:
      return null
  }
}
